/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter[_ngcontent-%COMP%]{display:flex;align-items:center;height:48px}.filter--sticky[_ngcontent-%COMP%]{position:-webkit-sticky;position:sticky;top:0;z-index:100;border-bottom:1px solid rgba(0,0,0,.08);background-color:#fff}.filter--margin[_ngcontent-%COMP%]{margin-left:10px;margin-right:10px}.filter__clear[_ngcontent-%COMP%]{font-weight:500;border-bottom:1px solid #9e9e9e70;height:48px;width:100%;text-align:left;background:#e4e4e4;border-radius:0}"];
export { styles as styles };
